import { render, staticRenderFns } from "./BrandSlide.vue?vue&type=template&id=625d0e02&scoped=true&"
import script from "./BrandSlide.vue?vue&type=script&lang=ts&"
export * from "./BrandSlide.vue?vue&type=script&lang=ts&"
import style0 from "./BrandSlide.vue?vue&type=style&index=0&id=625d0e02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625d0e02",
  null
  
)

component.options.__file = "BrandSlide.vue"
export default component.exports